<template>
  <div class="autocomplete">
    <v-textarea
      box
      hide-details
      auto-grow
      type="text"
      :id="id"
      :name="name"
      :label="label"
      @focusout="focusout"
      @focus="focus"
      @keydown.13="chooseItem"
      @keydown.tab="chooseItem"
      @keydown.40="moveDown"
      @keydown.38="moveUp"
      v-model="inputValue"
    ></v-textarea>

    <v-list
      :class="{
        'elevation-10': true,
        'autocomplete-list': true,
        [id + '-list']: true,
      }"
      v-if="searchMatch.length > 0"
    >
      <v-list-tile
        :key="index"
        :class="{ active: selectedIndex === index }"
        v-for="(result, index) in searchMatch"
        @click="selectItem(index), chooseItem()"
      >
        <v-list-tile-content>
          <v-list-tile-title>{{ result.name }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ result.label }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
export default {
  props: ["variables", "message", "label", "name"],
  data: () => ({
    inputValue: "",
    id: "input-" + parseInt(Math.random() * 1000),
    searchMatch: [],
    selectedIndex: 0,
    clickedChooseItem: false,
    wordIndex: 0,
  }),
  mounted() {
    this.inputValue = this.message
    const _self = this;
    document.querySelector("#" + this.id).addEventListener("input", function () {
      const caret = getCaretCoordinates(this, this.selectionEnd);

      if (_self.searchMatch.length > 0) {
        const element = document.querySelectorAll("." + _self.id + "-list");

        if (element[0]) {
          element[0].style.top = caret.top + 40 + "px";
          element[0].style.left = caret.left + "px";
        }
      }
    });
  },
  computed: {
    listToSearch() {
      if (typeof this.variables !== "undefined" && this.variables.length > 0) {
        return this.variables;
      } else {
        return [];
      }
    },
    currentWord() {
      if (this.inputValue) {
        return this.inputValue.replace(/(\r\n|\n|\r)/gm, " ").split(" ")[this.wordIndex];
      }
    },
    inputSplitted() {
      if (this.inputValue) {
        return this.inputValue.replace(/(\r\n|\n|\r)/gm, " ").split(" ");
      }
    },
  },
  watch: {
    message() {
      this.inputValue = this.message;
    },
    inputValue() {
      this.focus();
      this.$emit("message", this.inputValue);
      this.selectedIndex = 0;
      
      if (this.inputSplitted) {
        this.wordIndex = this.inputSplitted.length - 1;
      }
    },
  },
  methods: {
    highlightWord(word) {
      const regex = new RegExp("(" + this.currentWord + ")", "g");
      return word.replace(regex, "<mark>$1</mark>");
    },
    setWord(word) {
      let currentWords = this.inputValue.replace(/(\r\n|\n|\r)/gm, "__br__ ").split(" ");
      currentWords[this.wordIndex] = currentWords[this.wordIndex].replace(
        this.currentWord,
        word.name + " "
      );
      this.wordIndex += 1;
      this.inputValue = currentWords.join(" ").replace(/__br__\s/g, "\n");
    },
    moveDown() {
      if (this.selectedIndex < this.searchMatch.length - 1) {
        this.selectedIndex++;
      }
    },
    moveUp() {
      if (this.selectedIndex !== -1) {
        this.selectedIndex--;
      }
    },
    selectItem(index) {
      this.selectedIndex = index;
      this.chooseItem();
    },
    chooseItem(e) {
      this.clickedChooseItem = true;

      if (this.selectedIndex !== -1 && this.searchMatch.length > 0) {
        if (e) {
          e.preventDefault();
        }
        this.setWord(this.searchMatch[this.selectedIndex]);
        this.selectedIndex = -1;
      }
    },
    focusout(e) {
      setTimeout(() => {
        if (!this.clickedChooseItem) {
          this.searchMatch = [];
          this.selectedIndex = -1;
        }
        this.clickedChooseItem = false;
      }, 100);
    },
    focus() {
      this.searchMatch = [];
      if (this.currentWord !== "" && typeof this.currentWord != "undefined") {
        if (this.currentWord[0] == "$") {
          this.searchMatch = this.listToSearch.filter(
            (el) => el.name.indexOf(this.currentWord.toUpperCase()) >= 0
          );
        }
      }
      if (this.searchMatch.length == 1 && this.currentWord == this.searchMatch[0].name) {
        this.searchMatch = [];
      }
    },
  },
};

(function () {
  function e(b, e, f) {
    if (!h)
      throw Error(
        "textarea-caret-position#getCaretCoordinates should only be called in a browser"
      );
    if ((f = (f && f.debug) || !1)) {
      var a = document.querySelector("#input-textarea-caret-position-mirror-div");
      a && a.parentNode.removeChild(a);
    }
    a = document.createElement("div");
    a.id = "input-textarea-caret-position-mirror-div";
    document.body.appendChild(a);
    var c = a.style,
      d = window.getComputedStyle ? window.getComputedStyle(b) : b.currentStyle,
      k = "INPUT" === b.nodeName;
    c.whiteSpace = "pre-wrap";
    k || (c.wordWrap = "break-word");
    c.position = "absolute";
    f || (c.visibility = "hidden");
    l.forEach(function (a) {
      k && "lineHeight" === a ? (c.lineHeight = d.height) : (c[a] = d[a]);
    });
    m
      ? b.scrollHeight > parseInt(d.height) && (c.overflowY = "scroll")
      : (c.overflow = "hidden");
    a.textContent = b.value.substring(0, e);
    k && (a.textContent = a.textContent.replace(/\s/g, "\u00a0"));
    var g = document.createElement("span");
    g.textContent = b.value.substring(e) || ".";
    a.appendChild(g);
    b = {
      top: g.offsetTop + parseInt(d.borderTopWidth),
      left: g.offsetLeft + parseInt(d.borderLeftWidth),
      height: parseInt(d.lineHeight),
    };
    f ? (g.style.backgroundColor = "#aaa") : document.body.removeChild(a);
    return b;
  }
  var l = "direction boxSizing width height overflowX overflowY borderTopWidth borderRightWidth borderBottomWidth borderLeftWidth borderStyle paddingTop paddingRight paddingBottom paddingLeft fontStyle fontVariant fontWeight fontStretch fontSize fontSizeAdjust lineHeight fontFamily textAlign textTransform textIndent textDecoration letterSpacing wordSpacing tabSize MozTabSize".split(
      " "
    ),
    h = "undefined" !== typeof window,
    m = h && null != window.mozInnerScreenX;
  "undefined" != typeof module && "undefined" != typeof module.exports
    ? (module.exports = e)
    : h && (window.getCaretCoordinates = e);
})();
</script>

<style lang="scss">
// AUTOCOPMPLETE SCSS
.autocomplete {
  position: relative;
  &-list {
    position: absolute;
    z-index: 2;

    overflow: auto;

    min-width: 250px;
    max-height: 150px;
    margin: 0;
    margin-top: 5px;
    padding: 0;

    list-style: none;
    li {
      margin: 0;
      padding: 8px 15px;

      &:last-child {
        border-bottom: 0;
      }
    }
  }
}
</style>
